import { render, staticRenderFns } from "./ConnectionList.vue?vue&type=template&id=0b8fcfdc"
import script from "./ConnectionList.vue?vue&type=script&lang=js"
export * from "./ConnectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports